@if (fileWithHistory$ | async; as fileWithHistory) {
<article class="versions">
	<header class="page-header">
		<ul class="breadcrumb">
			<li>
				<a class="back" (click)="close()">
					<i class="ico ico-arrow-back"></i><span class="label" translate="back"></span>
				</a>
			</li>
		</ul>
		<h1 translate="files.revisions.title" [translateParams]="{ fileName: fileWithHistory.name }"></h1>
	</header>
	<article class="card">
		<div class="panel-component">
			<stages-media-switch>
				<table class="table center" *stagesMediaCase="Size.SMALL">
					<thead>
						<tr>
							<th class="avatar-cell"></th>
							<th translate="files.revisions.columnheader.modifiedBy"></th>
							<th translate="files.revisions.columnheader.date"></th>
							<th class="icon-cell versions"><i class="ico ico-pin"></i></th>
							<th translate="files.revisions.columnheader.identifier"></th>
							<th translate="files.revisions.columnheader.state"></th>
							<th translate="files.revisions.cellinfo.hiddenElements"></th>
							<th class="action"></th>
						</tr>
					</thead>
					<tbody>
						@for (version of fileWithHistory.revisions; track version) {
						<tr [ngClass]="{ disabled: !isDownloadable }">
							<td class="avatar-cell">
								<a class="clickable normal" (click)="downloadRevision(version)">
									<stages-user-image
										userId="{{ version.creator.id }}"
										[userName]="version.creator.fullname"
										version="{{ version.creator.profileImageVersion }}"
									></stages-user-image>
								</a>
							</td>
							<td>
								<a class="clickable normal" (click)="downloadRevision(version)">
									<h4>{{ version.creator.fullname }}</h4>
								</a>
							</td>
							<td>
								<a class="clickable normal" (click)="downloadRevision(version)">
									<p>{{ version.creationDate }}</p>
								</a>
							</td>
							<td class="icon-cell versions">
								@if (isFixedVersion(version, fileWithHistory)) {
								<i class="ico ico-pin"></i>
								}
							</td>
							<td>
								<a class="clickable normal" (click)="downloadRevision(version)">
									<p>{{ version.identifier }}</p>
								</a>
							</td>
							<td>
								<a class="clickable normal" (click)="downloadRevision(version)">
									<p [ngClass]="getFileStateClasses(version)">
										<span class="state-icon"></span>
										@if (version.stateMessageKey) {
										<span class="state-name" [translate]="version.stateMessageKey"></span>
										}
										@if (!version.stateMessageKey) {
											<span class="state-name">{{ version.state }}</span>
										}
									</p>
								</a>
							</td>
							<td>
								@if (showDropdown(version)) {
								<span class="counter">{{ getNumberOfElements(version) }}</span>
								}
							</td>
							<td class="label action">
								@if (showDropdown(version)) {
								<stages-button-expand-collapse
									[isCollapsed]="!expandedDropdown.isSelected(version)"
									[classes]="'menu-button'"
									(pressedButton)="expandedDropdown.toggleSelected(version)"
								></stages-button-expand-collapse>
								}
							</td>
						</tr>
						@if (showDropdown(version) && expandedDropdown.isSelected(version)) {
						<tr>
							<td></td>
							<td colspan="3" class="label">
								<div class="text center">
									@if (version.checkinComment) {
									<div class="dropdown-styling">
										<h4 translate="files.revisions.columnheader.comment"></h4>
										<p class="preformatted">{{ version.checkinComment }}</p>
									</div>
									}
									@if (version.labels.length) {
									<div class="dropdown-styling">
										<h4 translate="files.revisions.columnheader.tags"></h4>
										<p></p>
										<div class="tag-visualizer">
											@for (label of version.labels; track label) {
											<span>{{ label }}</span>
											}
										</div>
									</div>
									}
								</div>
							</td>
							<td colspan="3"></td>
						</tr>
						}
					}
					</tbody>
				</table>
				<ul class="list" *stagesMediaDefault>
					@for (version of fileWithHistory.revisions; track version) {
					<li class="list-item">
						<a class="label versions clickable normal" (click)="downloadRevision(version)">
							<div class="avatar-cell">
								<stages-user-image
									[userId]="version.creator.id"
									[userName]="version.creator.fullname"
									[version]="version.creator.profileImageVersion"
								></stages-user-image>
							</div>
							<div class="text center">
								<div class="justify-icon">
									<h4>{{ version.creator.fullname }}</h4>
									@if (isFixedVersion(version, fileWithHistory)) {
									<i class="ico ico-pin"></i>
									}
								</div>
								<p>
									{{ version.creationDate }}, {{ "files.revisions.columnheader.identifier.short" | translate }}:
									{{ version.identifier }}
								</p>
								<p [ngClass]="getFileStateClasses(version)">
									<span class="state-icon"></span>
									@if (version.stateMessageKey) {
									<span class="state-name" translate="{{ version.stateMessageKey }}"></span>
									}
									@if (!version.stateMessageKey) {
										<span class="state-name">{{ version.state }}</span>
									}
								</p>
								@if (showDropdown(version)) {
								<p>
									<span translate="files.revisions.cellinfo.hiddenElements"></span>
									<span class="counter">{{ getNumberOfElements(version) }}</span>
								</p>
								}
							</div>
						</a>
						@if (showDropdown(version)) {
						<stages-button-expand-collapse
							[isCollapsed]="!expandedDropdown.isSelected(version)"
							[classes]="'action menu-button'"
							(pressedButton)="expandedDropdown.toggleSelected(version)"
						></stages-button-expand-collapse>
						}
					</li>
					@if (expandedDropdown.isSelected(version) && showDropdown(version)) {
					<li class="list-item">
						<div class="label">
							<div class="avatar-cell"></div>
							<div class="text center">
								@if (version.checkinComment) {
								<div class="dropdown-styling">
									<h4 translate="files.revisions.columnheader.comment"></h4>
									<p class="preformatted">{{ version.checkinComment }}</p>
								</div>
								}
								<div class="list-space"></div>
								@if (version.labels.length) {
								<div class="dropdown-styling">
									<h4 translate="files.revisions.columnheader.tags"></h4>
									<div class="list-space"></div>
									@if (version.labels.length) {
									<div class="tag-visualizer">
										@for (label of version.labels; track label) {
										<span>{{ label }}</span>
										}
									</div>
									}
								</div>
								}
							</div>
						</div>
					</li>
					}
				}
				</ul>
			</stages-media-switch>
		</div>
	</article>
</article>
}
